import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { ObjectKeyPluckerTable } from '../../generic/KeyPlucker/ObjectKeyPluckerTable';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectKeyPluckerTableWidget = () => {
    const [{ applicationData }] = useContext(AppMainViewContext);
    const component = useMemo(() => _jsx(ObjectKeyPluckerTable, { objects: applicationData?.getApexNodes() }), [applicationData?.getContainedItems()]);
    return {
        name: 'ObjectKeyPluckerTable',
        category: 'generic',
        component,
    };
};
